
import { PropType } from 'vue';

export default {
  name: 'Button',
  props: {
    href: String,
    disabled: Boolean,
    variant: {
      type: String as PropType<'primary' | 'secondary' | 'link'>,
    },
  },
};
